export const ROHS_BRIEFING_ID_PREFIX = 'rohs'
